import React, { Fragment } from "react";
import Modal from "../../Modal/Modal";
import Spinner from "../../Spinner/Spinner";
import ModalSize from "../../Modal/ModalSize";

interface Props {
    title?: string
    message: string | undefined;
    onOkClick: (() => void) | undefined;
    onCancelClick?: () => void;
    showSpinnerOnOkClick?: boolean;
    size?: ModalSize
}
class WarningModal extends React.Component<Props, { title: string, isOpen: boolean, error: string | null }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            title: this.props.title || '',
            isOpen: true,
            error: null,
        };

        this.close = this.close.bind(this);
    }

    close(): void {
        this.setState({ isOpen: false });
        this.props.onCancelClick && this.props.onCancelClick();
    }

    render(): JSX.Element {
        return (
            <div key={this.props.message}>
                <Modal state={this.state} close={this.close} size={this.props.size || "medium"}>
                    <p className='white-space-pre-line'>{this.props.message}</p>
                    {this.props.children &&
                        this.props.children
                    }
                    <div className='display-flex align-center justify-content-start margin-top-20px'>
                        {this.props.showSpinnerOnOkClick ?
                            <button className='btn cb-btn width-75px' disabled>Ok<Spinner /></button>
                            :
                            <button key={1} className='btn cb-btn width-75px' onClick={() => { this.props.onOkClick && this.props.onOkClick(); }}>Ok</button>
                        }
                        <button key={2} className='btn btn-light' onClick={this.close}>Cancel</button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default WarningModal;